import { Injectable } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

@Injectable()
export class ProductService {

  private emileadSubmissionUrl= emiGlobals.commonLeadUrl;
  private headers: Headers ;
  private options: RequestOptions ;

  constructor(  private _http: Http) { 
    this.doRequest();
  }

  doRequest(){
    let token =  localStorage.getItem('id_token');
    this.headers= new Headers( {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }); 
    this.headers.append('Authorization','Bearer '+token);
    this.options = new RequestOptions ({ headers: this.headers} );
    console.log("doRequest",this.options);
  }


  public sentLeadInformation(){
    var totalLeadData = {};

    if(localStorage.getItem('choosen_product')){
      var localData = JSON.parse(localStorage.getItem('choosen_product'));
      totalLeadData['item']=localData;
      Object.keys(localData).forEach((key) => totalLeadData['item_'+key] = localData[key]);
    }
    if(localStorage.getItem('agentInfo')){
      var localData = JSON.parse(localStorage.getItem('agentInfo'));
      totalLeadData['agentInfo']=localData;
    }
    if(localStorage.getItem('lead_contact')){
      var localData = JSON.parse(localStorage.getItem('lead_contact'));
      Object.keys(localData).forEach((key) => totalLeadData[key] = localData[key]);
    }
    totalLeadData['lead_type']='custom_listing';
    console.log(totalLeadData); 

       return this._http
      .post(this.emileadSubmissionUrl,totalLeadData, this.options)
      .map(response => response.json())
      .subscribe(data=>{
        console.log("data sent");
      })
  }



}



// WEBPACK FOOTER //
// ./src/app/products/service/product.service.ts